import { ComponentPropsWithRef, MouseEventHandler, RefObject } from "react"

import { classNames } from "../../../../lib/classNames"

interface TextButtonProps extends ComponentPropsWithRef<"button"> {
  enableClickPropagation?: boolean
  ref?: RefObject<HTMLButtonElement | null>
}

export const TextButton = (props: TextButtonProps) => {
  const {
    ref,
    children,
    className,
    onClick,
    enableClickPropagation = false,
    ...otherProps
  } = props

  const handleClick: MouseEventHandler<HTMLButtonElement> = (event) => {
    if (!enableClickPropagation) {
      event.stopPropagation()
    }
    if (onClick) {
      onClick(event)
    }
  }

  return (
    <button
      ref={ref}
      type="button"
      className={classNames(
        "text-v2-foreground-primary hover:not-disabled:text-v2-foreground-primary-strong disabled:text-v2-foreground-primary-disabled text-label whitespace-nowrap underline",
        className
      )}
      onClick={handleClick}
      {...otherProps}
    >
      {children}
    </button>
  )
}

TextButton.displayName = "TextButton"
